export default __webpack_public_path__ + "static/media/10.e33b90b0.jpg";